export const MUTATION_ADD_DESIGN = 'ADD_DESIGN';
export const MUTATION_GET_PRICE = 'GET_PRICE';
export const MUTATION_IS_LOADED = 'IS_LOADED';
export const MUTATION_SET_EXPORT = 'SET_EXPORT';
export const MUTATION_SET_PRICE = 'SET_PRICE';
export const MUTATION_SET_PRODUCT_COLORS = 'SET_PRODUCT_COLORS';
export const MUTATION_UPDATE_EXPORT = 'UPDATE_EXPORT';
export const MUTATION_UPDATE_PRODUCT = 'UPDATE_PRODUCT';

import { NAMESPACE } from './namespace';

export const MUTATION_TYPE_PRODUCT_IS_LOADED = `${NAMESPACE}${MUTATION_IS_LOADED}`;
